import React, { useCallback, useEffect, useState } from "react";
import AuctionLots from "../../components/auctionLots/AuctionLots";
import { auctionV2ApiClient } from "../../auctions-list-page/AuctionApiClient";
import GoTopButton from "../../components/GoTopButton";
import styles from "./MyBids.module.scss";
import { formatPriceWs } from "../../utils/formatPrice";
import Spinner from "../../common/Spinner";
const ItemsPerPageLimit = 30;
export function MyBids({ strings, auctionUrl, isActive, bidType, defaultSortOrder, sortOrders }) {
    var _a;
    const [sortOrder, setSortOrder] = useState((_a = sortOrders
        .find(x => x.key === defaultSortOrder)) !== null && _a !== void 0 ? _a : sortOrders[0]);
    const [bidTotals, setBidTotals] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const getBidsTotals = async () => {
        const res = await auctionV2ApiClient.getUserBidsTotal();
        setBidTotals(res);
    };
    const getBids = useCallback(async (page) => {
        setIsLoading(true);
        const items = await auctionV2ApiClient.getUserBids({
            isActive: isActive.toString(),
            limit: ItemsPerPageLimit,
            page: page !== null && page !== void 0 ? page : "",
            type: bidType,
            sortOrder: sortOrder.key
        });
        setIsLoading(false);
        return items;
    }, [sortOrder]);
    function onSortOrderChange(e) {
        const key = parseInt(e.target.value);
        setSortOrder(sortOrders.find(t => t.key == key));
    }
    useEffect(() => {
        if (!isActive)
            return;
        void getBidsTotals();
    }, []);
    return (React.createElement("div", null,
        React.createElement("div", { className: styles.topBar },
            isActive &&
                React.createElement("div", { className: styles.sums },
                    React.createElement("label", null,
                        strings.myBidsStrings.totalBidsNumberLabel,
                        ":",
                        " ",
                        React.createElement("span", null, bidTotals === null || bidTotals === void 0 ? void 0 : bidTotals.totalNumberOfBids)),
                    React.createElement("label", null,
                        strings.myBidsStrings.totalHighestBidsNumberLabel,
                        ":",
                        " ",
                        React.createElement("span", null, bidTotals === null || bidTotals === void 0 ? void 0 : bidTotals.totalNumberOfHighestBids)),
                    React.createElement("label", null,
                        strings.myBidsStrings.totalHighestBidsSumLabel,
                        ":",
                        " ",
                        React.createElement("span", null, formatPriceWs(bidTotals === null || bidTotals === void 0 ? void 0 : bidTotals.totalSumOfHighestBids)))),
            React.createElement("div", { className: styles.selectList },
                React.createElement("label", null,
                    strings.myBidsStrings.sortOrderLabel,
                    ":"),
                React.createElement("select", { value: sortOrder.key, onChange: onSortOrderChange }, sortOrders.map((itm) => (React.createElement("option", { key: itm.key, value: itm.key }, itm.value)))))),
        isLoading && React.createElement(Spinner, { size: "small" }),
        React.createElement(AuctionLots, { auctionUrl: auctionUrl, getItems: getBids, strings: strings, viewMode: "grid", auctionStatus: 0, showOnlyActive: false, saveItemPositionState: () => {
            }, itemsPerPageLimit: ItemsPerPageLimit }),
        React.createElement(GoTopButton, { label: strings.auctionLot.backToTopButton })));
}
